export default __webpack_public_path__ + "static/altanki-03ade3e99947053a75ab3ec123ad07ce.jpg";